'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dSites$002dPage$0024 from "./presto.-List-Sites-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002487 from "./presto.-Presto-Router$$anon$87.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$86() {
  this.bnC = null;
  this.bnu = null;
  this.bnv = false;
  this.bnD = null;
  this.bnE = false;
  this.bnH = null;
  this.bnA = null;
  this.bnB = false;
  this.bnw = null;
  this.bnx = false;
  this.bny = null;
  this.bnz = false;
  this.bnF = false;
  this.bnG = false;
  this.bnC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bnH = "ListSitesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$86 as $c_Lpresto_PrestoRouter$$anon$86 };
$p = $c_Lpresto_PrestoRouter$$anon$86.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$86;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$86() {
}
export { $h_Lpresto_PrestoRouter$$anon$86 as $h_Lpresto_PrestoRouter$$anon$86 };
$h_Lpresto_PrestoRouter$$anon$86.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bnC;
});
$p.M = (function() {
  if ((!this.bnv)) {
    this.bnu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bnv = true;
  }
  return this.bnu;
});
$p.O = (function() {
  if ((!this.bnE)) {
    this.bnD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bnE = true;
  }
  return this.bnD;
});
$p.E = (function() {
  return this.bnH;
});
$p.t = (function() {
  if ((!this.bnB)) {
    this.bnA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnB = true;
  }
  return this.bnA;
});
$p.N = (function() {
  if ((!this.bnx)) {
    this.bnw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnx = true;
  }
  return this.bnw;
});
$p.Q = (function() {
  if ((!this.bnz)) {
    this.bny = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002487.$c_Lpresto_PrestoRouter$$anon$87();
    this.bnz = true;
  }
  return this.bny;
});
$p.v = (function() {
  if ((!this.bnG)) {
    this.bnF = false;
    this.bnG = true;
  }
  return this.bnF;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee556) => ((p) => \u03b4scrutinee556))($j_presto$002e$002dList$002dSites$002dPage$0024.$m_Lpresto_ListSitesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$86 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$86, "presto.PrestoRouter$$anon$86", ({
  P4: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$86 as $d_Lpresto_PrestoRouter$$anon$86 };
//# sourceMappingURL=presto.-Presto-Router$$anon$86.js.map
